export enum PharmacyRadiusEnum {
  '5_MILES' = '5 miles',
  '10_MILES' = '10 miles',
  '20_MILES' = '20 miles',
  '50_DAYS' = '50 miles',
}
